<p-button [text]="true" [rounded]="true" severity="secondary" (onClick)="op.toggle($event)" pTooltip="Language / Lingua">
  <span [class]="getCurrentFlagClass()"></span>
</p-button>

<p-popover #op>
  <div class="language-selector">
    @for (lang of languages; track lang.code) {
      <button class="language-option" [class.active]="currentLang === lang.code" (click)="switchLanguage(lang.code); op.hide()">
        <span [class]="lang.flagClass + ' flag-icon'"></span>
        <span class="name">{{ lang.name }}</span>
        @if (currentLang === lang.code) {
          <i class="pi pi-check ml-auto"></i>
        }
      </button>
    }
  </div>
</p-popover>
